export const PRIORITY_LIST_LOGICAL_ID_PREFIX = 'priority_list:';
